export default __webpack_public_path__ + "static/media/08.fecb3c32.jpg";